import React from "react";
import { IconProps } from "../../types/component";
import useChakraColor from "../../hooks/useChakraColor";

export const Novice: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_6398_18421)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#008905"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6398_18421"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A5EFA7" />
        <stop offset="1" stopColor="#1ED524" />
      </linearGradient>
    </defs>
  </svg>
);

export const Bronze: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_6398_18417)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#BD2306"
    />
    <path
      d="M38 0L49.9244 9.21191L64.8701 11.1299L66.7881 26.0756L76 38L66.7881 49.9244L64.8701 64.8701L49.9244 66.7881L38 76L26.0756 66.7881L11.1299 64.8701L9.21191 49.9244L0 38L9.21191 26.0756L11.1299 11.1299L26.0756 9.21191L38 0Z"
      fill="url(#paint1_linear_6398_18417)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6398_18417"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F18661" />
        <stop offset="1" stopColor="#ED6938" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6398_18417"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDACD" />
        <stop offset="1" stopColor="#BD2306" />
      </linearGradient>
    </defs>
  </svg>
);

export const Silver: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_6398_18426)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#929197"
    />
    <path
      d="M38 0L46.0648 7.90175L57 5.09103L60.0334 15.9666L70.909 19L68.0983 29.9352L76 38L68.0983 46.0648L70.909 57L60.0334 60.0334L57 70.909L46.0648 68.0983L38 76L29.9352 68.0983L19 70.909L15.9666 60.0334L5.09103 57L7.90175 46.0648L0 38L7.90175 29.9352L5.09103 19L15.9666 15.9666L19 5.09103L29.9352 7.90175L38 0Z"
      fill="url(#paint1_linear_6398_18426)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6398_18426"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3E9E9" />
        <stop offset="1" stopColor="#BCCBD2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6398_18426"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFE6E7" />
        <stop offset="1" stopColor="#929197" />
      </linearGradient>
    </defs>
  </svg>
);

export const Gold: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_6398_18430)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#E48005"
    />
    <path
      d="M38 0L44.079 7.43873L52.542 2.89258L55.3116 12.0914L64.8701 11.1299L63.9086 20.6884L73.1074 23.458L68.5613 31.921L76 38L68.5613 44.079L73.1074 52.542L63.9086 55.3116L64.8701 64.8701L55.3116 63.9086L52.542 73.1074L44.079 68.5613L38 76L31.921 68.5613L23.458 73.1074L20.6884 63.9086L11.1299 64.8701L12.0914 55.3116L2.89258 52.542L7.43873 44.079L0 38L7.43873 31.921L2.89258 23.458L12.0914 20.6884L11.1299 11.1299L20.6884 12.0914L23.458 2.89258L31.921 7.43873L38 0Z"
      fill="url(#paint1_linear_6398_18430)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6398_18430"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F7DA0C" />
        <stop offset="1" stopColor="#F7C208" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6398_18430"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE53F" />
        <stop offset="1" stopColor="#E48005" />
      </linearGradient>
    </defs>
  </svg>
);

export const Diamond: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_6398_18434)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#0199D1"
    />
    <path
      d="M38 0L42.8745 7.22363L49.7426 1.85985L52.1463 10.2362L60.3358 7.25735L60.0334 15.9666L68.7426 15.6642L65.7638 23.8537L74.1402 26.2574L68.7764 33.1255L76 38L68.7764 42.8745L74.1402 49.7426L65.7638 52.1463L68.7426 60.3358L60.0334 60.0334L60.3358 68.7426L52.1463 65.7638L49.7426 74.1402L42.8745 68.7764L38 76L33.1255 68.7764L26.2574 74.1402L23.8537 65.7638L15.6642 68.7426L15.9666 60.0334L7.25735 60.3358L10.2362 52.1463L1.85985 49.7426L7.22363 42.8745L0 38L7.22363 33.1255L1.85985 26.2574L10.2362 23.8537L7.25735 15.6642L15.9666 15.9666L15.6642 7.25735L23.8537 10.2362L26.2574 1.85985L33.1255 7.22363L38 0Z"
      fill="url(#paint1_linear_6398_18434)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6398_18434"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBF8FE" />
        <stop offset="1" stopColor="#90D6E6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6398_18434"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CEECF4" />
        <stop offset="1" stopColor="#0199D1" />
      </linearGradient>
    </defs>
  </svg>
);

export const Custom: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38Z"
      fill="url(#paint0_linear_1_2)"
    />
    <path
      d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM7.07397 38C7.07397 55.08 20.92 68.926 38 68.926C55.08 68.926 68.926 55.08 68.926 38C68.926 20.92 55.08 7.07397 38 7.07397C20.92 7.07397 7.07397 20.92 7.07397 38Z"
      fill="#0C727E"
    />
    <path
      d="M38 0L44.079 7.43873L52.542 2.89258L55.3116 12.0914L64.8701 11.1299L63.9086 20.6884L73.1074 23.458L68.5613 31.921L76 38L68.5613 44.079L73.1074 52.542L63.9086 55.3116L64.8701 64.8701L55.3116 63.9086L52.542 73.1074L44.079 68.5613L38 76L31.921 68.5613L23.458 73.1074L20.6884 63.9086L11.1299 64.8701L12.0914 55.3116L2.89258 52.542L7.43873 44.079L0 38L7.43873 31.921L2.89258 23.458L12.0914 20.6884L11.1299 11.1299L20.6884 12.0914L23.458 2.89258L31.921 7.43873L38 0Z"
      fill="url(#paint1_linear_1_2)"
    />
    <path
      d="M38.0002 68.9263C20.9203 68.9263 7.07422 55.0802 7.07422 38.0002C7.07422 20.9203 20.9203 7.07422 38.0002 7.07422C55.0802 7.07422 68.9263 20.9203 68.9263 38.0002C68.9263 55.0802 55.0802 68.9263 38.0002 68.9263Z"
      fill="url(#paint2_linear_1_2)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_2"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F7DA0C" />
        <stop offset="1" stopColor="#F7C208" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_2"
        x1="38"
        y1="0"
        x2="38"
        y2="76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4B396" />
        <stop offset="1" stopColor="#0C727E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_2"
        x1="38.0002"
        y1="7.07422"
        x2="38.0002"
        y2="68.9263"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2BCA2" />
        <stop offset="1" stopColor="#E67D4F" />
      </linearGradient>
    </defs>
  </svg>
);
